import { createFileRoute } from "@tanstack/react-router";
import { MultilingualServiceLanding } from "@/components/MultilingualServiceLanding";
import { DE_SERVICES } from "@/data/de-service-content";
import { SEO_SITE, multiHreflangLinks, ctaDesc, ctaTitle } from "@/lib/seo";

const PATH = "/de/services";
const C = DE_SERVICES;

export const Route = createFileRoute("/de/services")({
  head: () => ({
    meta: [
      { title: ctaTitle("Rechtsdienstleistungen in Bangkok auf Deutsch | NYC Legal", "/de/services", "th")},
      { name: "description", content: ctaDesc("Deutschsprachiger Rechts-Desk in Bangkok: Notar, Übersetzung, Apostille, Ehe, Visa, Work Permit. Send your documents for a free eligibility check.", "/de/services", "th")},
      { property: "og:title", content: ctaTitle("Deutschsprachige Rechtsdienste Bangkok | NYC Legal", "/de/services", "th")},
      { property: "og:description", content: ctaDesc("Komplette Begleitung deutschsprachiger Mandanten in Thailand.", "/de/services", "th")},
      { property: "og:url", content: `${SEO_SITE}${PATH}` },
      { property: "og:locale", content: "de_DE" },
    ],
    links: [
      { rel: "canonical", href: `${SEO_SITE}${PATH}` },
      ...multiHreflangLinks(
        [
          { hreflang: "th-TH", path: "/services" },
          { hreflang: "en", path: "/en/services" },
          { hreflang: "zh", path: "/zh/services" },
          { hreflang: "ja", path: "/ja/services" },
          { hreflang: "ko", path: "/ko/services" },
          { hreflang: "ru", path: "/ru/services" },
          { hreflang: "de", path: "/de/services" },
          { hreflang: "x-default", path: "/services" },
        ],
        "/services",
      ),
    ],
    scripts: [
      { type: "application/ld+json", children: JSON.stringify({
        "@context": "https://schema.org", "@type": "LegalService",
        name: "NYC Legal — German Desk", url: `${SEO_SITE}${PATH}`,
        areaServed: ["TH", "DE", "AT", "CH"], inLanguage: "de",
        priceRange: "฿1,500–฿50,000",
        provider: { "@type": "LegalService", name: "NYC Language Institute", url: SEO_SITE },
      }) },
      { type: "application/ld+json", children: JSON.stringify({
        "@context": "https://schema.org", "@type": "FAQPage", inLanguage: "de",
        mainEntity: C.faqs.map((f) => ({ "@type": "Question", name: f.q,
          acceptedAnswer: { "@type": "Answer", text: f.a } })),
      }) },
      { type: "application/ld+json", children: JSON.stringify({
        "@context": "https://schema.org", "@type": "BreadcrumbList",
        itemListElement: [
          { "@type": "ListItem", position: 1, name: "Startseite", item: `${SEO_SITE}/de` },
          { "@type": "ListItem", position: 2, name: "Leistungen", item: `${SEO_SITE}${PATH}` },
        ],
      }) },
    ],
  }),
  component: () => <MultilingualServiceLanding c={C} />,
});
